import { Plan } from '../plan';

export class Simo extends Plan {
    public static readonly PLAN_TYPE = 'plan_simo';
    public static readonly COVER_URL = 'assets/images/plans/simo/cover_desktop-simo.jpg';
    public static readonly COVER_URL_MOBILE = 'assets/images/plans/simo/cover_mobile-simo.jpg';
}

export const SimoSubCategories = ['plan_simo_selection', 'plan_simo_entry', 'plan_simo_multiligne'];
